import React, { useState, useEffect } from "react";
import { Anchor as AntdAnchor } from "antd";
import "./style.scss";

function Anchor({
  direction = "horizontal",
  items = [],
  targetOffset,
  className,
  ...props
}) {
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash) {
      const hash = window.location.hash;
      if (items.some((item) => item.href === hash)) {
        setActiveLink(hash);
        return;
      }
    }

    if (items.length && !activeLink) {
      setActiveLink(items[0].href);
    }
  }, [items, activeLink]);

  return (
    <AntdAnchor
      className={`anchor-frame ${!activeLink ? "no-active" : ""} ${className}`}
      direction={direction}
      items={items}
      affix={false}
      targetOffset={targetOffset}
      bounds={5}
      onChange={(currentActiveLink) => setActiveLink(currentActiveLink)}
      {...props}
    />
  );
}

export default Anchor;
